import { useEffect, useState } from "react";
import { getMeteoData } from "../api/meteo";

export const useGetMeteoRainLastHours = ({ meteoId, start, end }) => {
    const [observations, setObservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRain = async () => {
      try {
        const result = await getMeteoData({
          meteoId,
          start,
          end,
          parameter: "rainStorm"
        });

        

        setObservations(result);
      } catch (error) {
        setError(error);
        console.error("Error al obtener la lluvia de la meteo:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRain();
  }, [meteoId, start, end]);

  return { observations, loading, error };
};
